import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import API from "src/services/api";

const MultiVideoUploader = ({ swipeId, trigger }) => {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(null);

  const [data, setData] = useState([]);

  const loadData = async () => {
    const d = await API.getSwipeVideos(swipeId);
    if (d.data) {
      setData(d.data);
    }
  };

  useEffect(() => {
    loadData();
  }, [trigger]);

  const handleFiles = (selectedFiles) => {
    const fileArray = Array.from(selectedFiles);
    setFiles((prev) => [...prev, ...fileArray]);
    setUploadSuccess(null);
  };

  const handleFileChange = (e) => {
    handleFiles(e.target.files);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files) {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleUpload = async () => {
    if (files.length === 0) return;

    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append("video[]", file); // "images" muss ggf. zum Backend passen
    });

    try {
      setUploading(true);
      const response = await API.uploadSwipeVideo(swipeId, formData);
      loadData();
      console.log("Upload erfolgreich:", response.data);
      setUploadSuccess(true);
      setFiles([]);
    } catch (error) {
      console.error("Fehler beim Upload:", error);
      setUploadSuccess(false);
    } finally {
      setUploading(false);
    }
  };

  const deleteMedia = async (mediaId) => {
    if (window.confirm("Bild löschen?")) {
      await API.deleteMedia(mediaId);
      loadData();
    }
  };

  return (
    <React.Fragment>
      <Row>
        {data.map((i) => (
          <Col xs={4} className="add-margin">
            <img
              src={`${i.urlImage ? i.urlImage : i.url}`}
              style={{ width: "100%" }}
            />
            <Button onClick={() => deleteMedia(i.id)} variant="danger">
              löschen
            </Button>
          </Col>
        ))}
      </Row>
      <Row>
        <div
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          style={{
            borderWidth: 2,
            borderStyle: "dashed",
            borderColor: "gray",
            margin: 15,
            textAlign: "center",
            padding: 15,
          }}
        >
          <p className="text-gray-500">
            Ziehen Sie Videos hierher oder klicken Sie zum Auswählen
          </p>
          <input
            type="file"
            accept="video/*"
            multiple
            onChange={handleFileChange}
            style={{ display: "none" }}
            className="hidden"
            id="fileInput"
          />
          <label
            htmlFor="fileInput"
            className="cursor-pointer block mt-2 text-blue-500 underline"
          >
            Bilder auswählen
          </label>
        </div>

        {files.length > 0 && (
          <div className="grid grid-cols-3 gap-2">
            {files.map((file, index) => (
              <img
                key={index}
                src={URL.createObjectURL(file)}
                alt={`preview ${index}`}
                style={{ maxWidth: "100px" }}
                className="w-full h-24 object-cover rounded"
              />
            ))}
          </div>
        )}
      </Row>
      <Row>
        <Col>
          <Button
            variant="primary"
            onClick={handleUpload}
            style={{ marginTop: 15, width: "100%" }}
            disabled={files.length === 0 || uploading}
          >
            {uploading ? "Wird hochgeladen..." : "Alle hochladen"}
          </Button>

          {uploadSuccess === true && (
            <p className="text-green-600">Upload erfolgreich!</p>
          )}
          {uploadSuccess === false && (
            <p className="text-red-600">Upload fehlgeschlagen.</p>
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default MultiVideoUploader;
